<template>
    <div id="app">
        <keep-alive include="customer">
            <router-view />
        </keep-alive>
    </div>
</template>
<script>
    export default {

    }
</script>
<style lang="less">
    @import "./styles/common.css";
    @import "./styles/overall.less";

    html {
        background: linear-gradient(180deg, #6A7FFF 0%, #F5F6FC 26.92%) no-repeat;
        min-height: 100%;
    }

    input {
        border: 0;
    }

    .s2 {
        color: red !important;
        display: inline-block;
    }

    input:focus {
        outline: none;
        /* 移除点击输入框默认产生的轮廓 */
    }

    select:focus {
        outline: none;
        /* 移除点击输入框默认产生的轮廓 */
    }

    //顶部返回首页
    .top_title {
        width: 100%;
        position: relative;

        .top_back_home {
            position: absolute;
            left: 3px;
            top: 0px;
            display: flex;
            align-items: center;
            cursor: pointer;
            img {
                display: block;
                width: 20px;
                height: 20px;
                margin-right: 3px;
            }

            p {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 44px;
            }
        }

        .title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 44px;
            text-align: center;
        }
    }
</style>
